import { Injectable } from '@angular/core';
import { CUSTOM_OFFER_TOKEN_STORAGE_KEY } from '../Consts/custom-offer-token.const';

@Injectable({
  providedIn: 'root',
})
export class CustomOfferTokenService {
  store(token: string): void {
    try {
      sessionStorage.setItem(CUSTOM_OFFER_TOKEN_STORAGE_KEY, token);
    } catch {
      return;
    }
  }

  read(): string | null {
    try {
      return sessionStorage.getItem(CUSTOM_OFFER_TOKEN_STORAGE_KEY);
    } catch {
      return null;
    }
  }

  clear(): void {
    try {
      sessionStorage.removeItem(CUSTOM_OFFER_TOKEN_STORAGE_KEY);
    } catch {
      return;
    }
  }
}
